import HttpRequest from './httpRequest'

export default class OrderProvider extends HttpRequest {
  createOrder(params) {
    return this.create('/orders', params)
  }

  fetchOrderById(id) {
    return this.fetch(`/orders/${id}`)
  }

  fetchOrders(params) {
    return this.fetch('/orders', params)
  }

  fetchOrdersByUserId(params) {
    return this.fetch('/orders/users', params)
  }

  updateOrderById(id, params) {
    return this.update(`/orders/${id}`, params)
  }

  updateOrderPayments(id, params) {
    return this.update(`/orders/payments/${id}`, params)
  }

  deleteOrderById(id) {
    return this.update(`/orders/delete/${id}`)
  }

  fetchRevenue (id) {
    return this.fetch(`/orders/revenue/${id}`)
  }

  fetchReceiptUrl (id) {
    return this.fetch(`/orders/receipt/${id}`)
  }

  downloadReceipt (id) {
    // Use fetchRaw to get full response with headers (bypasses response.data interceptor)
    // This is needed to access Content-Disposition header for the filename
    return this.fetchRaw(`/orders/receipt/${id}/download`, {
      responseType: 'blob'
    })
  }

  fetchWithholdingTaxRejectionFilesUrls (orderId) {
    return this.fetch(`/orders/withholding-tax-rejection-files/${orderId}`)
  }
}
